import { animate, state, style, transition, trigger, AnimationTriggerMetadata } from '@angular/animations';

export function fadeInOutFactory(time: string = '100ms'): AnimationTriggerMetadata {
  return trigger(
    'fadeInOut',
    [
      state('hidden', style({ opacity: 0 })),
      state('visible', style({ opacity: 1 })),
      transition('* => *', [
        animate(time, style({ opacity: .5 })),
      ]),
    ]
  );
}

export const fadeInOut = fadeInOutFactory();

export const slideOut = trigger('slideOut', [
  state(':leave', style({ opacity: 0 })),
  state(':enter', style({ opacity: 1 })),
  transition('0 => 1', [
    style({ transform: 'translateX(100%)', opacity: 0 }),
    animate('500ms ease-in', style({ transform: 'translateX(-100%)', opacity: 1 })),
  ]),
]);

export const zoomInOut = trigger(
  'zoomInOut',
  [
    state(':enter', style({ width: '2.5rem' })),
    state('animating', style({ width: '2.5rem' })),
    state(':leave', style({ width: '0' })),
    transition('* <=> *', [
      animate('250ms', style({ width: '2.5rem' })),
    ]),
  ]
);
